import { Box, IconButton } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { AdministrationPage } from "../administration/AdministrationPage";
import { DashboardsRoutePage } from "../dashboards/DashboardsRoutePage";
import {
  AppState,
  REMOVE_APP_FEEDBACK,
  ReportFeedbackAction,
  REPORT_APP_FEEDBACK
} from "../redux/AppTypes";
import fetchService from "../utils/FetchService";
import { useSynching } from "../utils/useSynching";
import "./App.css";
import { SideNav } from "./SideNav";
import { theme, tokens } from "./theme";
import { TopBar } from "./TopBar";

export function AuthorizedApp() {
  const dispatch = useDispatch();
  const synching = useSynching();
  const feedback = useSelector((state: AppState) => state.feedback);

  useEffect(() => {
    fetchService.subscribe({
      onError: (message) => {
        const action: ReportFeedbackAction = {
          type: REPORT_APP_FEEDBACK,
          feedback: message,
        };
        dispatch(action);
      },
    });
  }, [dispatch]);

  const removeFeedback = () => {
    dispatch({ type: REMOVE_APP_FEEDBACK });
  };

  return (
    <Box
      style={{
        display: "grid",
        gridTemplateColumns: "220px 1fr",
        gridTemplateRows: "minmax(0, 1fr)",
        height: "100vh",
        position: "relative",
        zIndex: 1,
        overflow: "hidden",
      }}
    >
      <SideNav />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          height: "100%",
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <TopBar />
        <div style={{ height: 2, flex: "none", overflow: "hidden" }}>
          {synching.any ? (
            <div
              style={{
                height: 2,
                width: "22%",
                background: `linear-gradient(90deg, transparent, ${tokens.primary}, transparent)`,
                animation: "loadbar 0.9s linear infinite",
              }}
            />
          ) : null}
        </div>
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            padding: "18px 22px 44px",
          }}
        >
          <Switch>
            <Route path="/dashboards">
              <DashboardsRoutePage />
            </Route>
            <Route path="/administration">
              <AdministrationPage />
            </Route>
            <Route path="/docs">Not found</Route>
            <Route path="/">
              <Redirect to="/dashboards" />
            </Route>
          </Switch>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={feedback.length > 0}
        autoHideDuration={6000}
        message={feedback[0]}
        onClose={removeFeedback}
        ContentProps={{
          style: {
            background: tokens.surface2,
            color: tokens.fg1,
            border: `1px solid ${tokens.hairlineStrong}`,
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
            borderRadius: 10,
            boxShadow: "0 16px 40px rgba(0,0,0,0.55)",
            font: `400 13px/1.3 ${theme.typography.fontFamily}`,
          },
        }}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={removeFeedback}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </Box>
  );
}
